import { SaleStatusEnum, StatusEnum, TypeOfStock } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, CreateDateColumn, Entity, Index, JoinColumn, OneToMany, OneToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("stock_log")

export class StockLog {

    @PrimaryGeneratedColumn("increment", { name: 'stock_log_id' })
    stockLogId: number;

    @Column("int", {
        nullable: false,
        name: "unit_id"
    })
    unitId: number;

    // @Column({ type: 'decimal', precision: 10, scale: 2, default: 0, unsigned: true, name: "physical_quantity" })
    // physicalQuantity: number;

    @Column("decimal", {
        nullable: false,
        name: "quantity",
        precision:10,scale:3,
        unsigned:true,
        default:0
    })
    quantity: number;

    @Column("int", {
        nullable: false,
        name: "item_id"
    })
    itemId: number;
    @Column("int", {
        nullable: false,
        name: "saleorder_id"
    })
    saleOrderId: number;
    @Column("int", {
        nullable: false,
        name: "grn_id",
        default:0,
    })
    grnId: number;

    @Column("int", {
        nullable: false,
        name: "grn_item_id",
        default:0,
    })
    grnItemId: number;


    @Column("int", {
        nullable: false,
        name: "location_id",
        default:0,
    })
    locationId: number;
    @Column("int", {
        nullable: false,
        name: "stock_id",
        default:0,
    })
    stockId: number;

    @Column({
        type: 'enum',
        enum: TypeOfStock,
        nullable: true,
        name: "type",
        default:TypeOfStock.GOOD,
    })
    type: TypeOfStock;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;


    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;



    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

}

